import { ActivityProxy, EnterpriseProxy, UserEnterpriseInfoViewModel, UserEnterpriseInfoViewModelListResponseResult } from '@/app/proxy/proxies';
import { SharedModule } from '@/app/shared/shared.module';
import { Component, OnInit } from '@angular/core';
import { finalize, forkJoin, tap } from 'rxjs';
import { ActivitiesService } from './activities.service';
import { ActivitiesHeaderComponent } from './components/activities-header/activities-header.component';

@Component({
  selector: 'app-activities',
  imports: [SharedModule, ActivitiesHeaderComponent],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.less',
  providers: [ActivityProxy]
})
export class ActivitiesComponent implements OnInit {
  loadingEnterprises = false;
  constructor(
    private _enterpriseProxy: EnterpriseProxy,
    private _activitiesService: ActivitiesService,
    private _activityProxy: ActivityProxy
  ) { }

  ngOnInit(): void {
    forkJoin(
      [
        this._activityProxy.activity_GetActivityTypes(),
        this._activityProxy.activity_GetActivityStatuses(),
        this.getUserEnterprises(), 
      ]
    ).subscribe(([types, statuses, _]) => {
      this._activitiesService.activityTypes = types?.result ?? [];
      this._activitiesService.activityStatuses = statuses?.result ?? [];
    });
  }

  getUserEnterprises() {
    this.loadingEnterprises = true;
    return this._enterpriseProxy
      .enterprise_GetUserEnterprises()
      .pipe(
        tap((res: UserEnterpriseInfoViewModelListResponseResult) => {
          if (res.isSuccess) {
            if (res.result?.length > 0) {
              this._activitiesService.setUserEnterprises(res.result);

              let selectedEnterprise: UserEnterpriseInfoViewModel;
              const storedSelectedEnterpriseId = localStorage.getItem(this._activitiesService.ENTERPRISE_STORAGE_KEY);
              if (storedSelectedEnterpriseId) {
                selectedEnterprise = res.result.find(e => e.enterpriseId === storedSelectedEnterpriseId)
              }
              this._activitiesService.setSelectedEnterprise(selectedEnterprise ?? res.result[0]);
            }
          }
        }),
        finalize(() => {
          this.loadingEnterprises = false;
        })
      );
  }
}
